/**
 * Fun Challenges Lobby route.
 *
 * Reachable from PlayChess → "Fun Challenges" tile in `GameSearch`. Phase 4
 * replaces the Phase 1 placeholder with the real lobby (game-type tile,
 * opponent picker, challenge settings).
 *
 * Side-effect imports `@/Screens/FunChallenges/adapters` so every battle adapter is
 * registered before the user picks a battle type.
 *
 * 2026-05-20 bug 3: if the user lands here while a fun challenge battle
 * is still active (e.g. they navigated away via the side menu and then
 * tapped Fun Challenges again), bounce them back to FunChallengeBattle.
 * The existing header pill ("Challenge in progress") already covers the
 * passive case, but the menu tap should reuse the live battle, not let
 * the user start a second one.
 */

import React, {useEffect} from 'react';

import {useNavigation} from '@react-navigation/native';

import BattleLobby from './components/BattleLobby';
import useFunChallengesBattleStore from '@/Store/funChallengesBattleStore';
import {ScreenName} from '@/navigators/StackConstants';

import '@/Screens/FunChallenges/adapters';

export default function FunChallengesLobby() {
  const navigation = useNavigation<any>();
  const status = useFunChallengesBattleStore(s => s.status);
  const battleId = useFunChallengesBattleStore(s => s.session?.battleId);

  useEffect(() => {
    if (status !== 'in_battle' || !battleId) return;
    try {
      navigation.navigate(ScreenName.FunChallengeBattle);
    } catch {
      // Navigation may not be ready in some auth states — non-fatal.
    }
  }, [status, battleId, navigation]);

  return <BattleLobby />;
}
